module.exports = __webpack_public_path__ + "media/images/brands/brand-bb-1f2609d891912a5606ebe2065adf1fed.jpg";